exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UploadImageModal-module__wrapper___3MpY_{display:grid;gap:1.5rem}.UploadImageModal-module__wrapper___3MpY_ form{display:grid;gap:1rem}.UploadImageModal-module__wrapper___3MpY_ form .UploadImageModal-module__button-wrapper___2KILF{margin:20px 0 0 auto}.UploadImageModal-module__wrapper___3MpY_ h2{line-height:1}.UploadImageModal-module__wrapper___3MpY_ .UploadImageModal-module__button-wrapper___2KILF{display:grid;justify-content:end;gap:.75rem;grid-auto-flow:column}", ""]);

// exports
exports.locals = {
	"wrapper": "UploadImageModal-module__wrapper___3MpY_",
	"button-wrapper": "UploadImageModal-module__button-wrapper___2KILF"
};